<template>
  <div/>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'notfound',
  computed: {
    ...mapState(['isTest', 'isAgreed', 'isAnswered', 'uid']),
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  mounted () {
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    } else if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    } else if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    } else {
      this.$router.push({name: 'RouteSearch'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Pages/NotFound.vue